import testi from './PriceCard.module.scss'

import { NavLink } from '@/components/atoms/NavLink/NavLink'

const PriceCard = ({ title, from, amount, monthly, annual, save, list1, list2, list3, list31, list4, list5, list51, list6, list61, list7, list8, list9, btn, extrauser, links }) => {
  return (
    <div className={testi.card}>
      <div className={testi.column}>
        <div className={testi.horizontal}>

          <div className={testi.verticalText}>
            <p className={testi.title}>{title}</p>
            <div className={testi.title1_3}>
              <span className={testi.currency}>
                <br className={testi.block} />
                {from}
              </span>
            </div>
            <p className={testi.title1_2}>
              <span className={testi.price}>$</span>
              <span className={testi.amount}>{amount}</span>
              <span className={testi.currency}>
                <br className={testi.block} />
                MXN <span className={testi.monthly}>{monthly}</span>
              </span>
            </p>
            <div className={testi.title1_4}>
              <span className={testi.currency}>
                <br className={testi.block} />
                {annual} <span className={testi.monthly}>{save}</span>
              </span>
            </div>
            <div className={testi.lista}>
              <p className={testi.title2}>{list1}</p>
              <p className={testi.title2}>{list2}</p>
              <p className={testi.title2}>{list3}</p>
              <p className={testi.title3}>{list31} </p>
              <p className={testi.title2}>{list4}</p>
              <p className={testi.title2}>{list5}</p>
              <p className={testi.title3}>{list51} </p>
              <p className={testi.title2}>{list6}</p>
              <p className={testi.title3}>{list61} </p>
              <p className={testi.title2}>{list7}</p>
              <p className={testi.title2}>{list8}</p>
              <p className={testi.title2}>{list9}</p>
            </div>
            <div className={testi.lista2}>
              <NavLink href={links} name={btn} className={testi.button1} />
            </div>
            <div className={testi.title1_3}>
              <span className={testi.currency2}>{extrauser}</span>
            </div>

          </div>

        </div>
      </div>
      <div className={testi.column} />
    </div>
  )
}

export default PriceCard
